import { SHA256 } from 'crypto-js';

interface ISignProps {
    uuid: string;
    userId: string;
}
export const generateUserSign = ({ uuid = '', userId = '' }: ISignProps) => {
    const combinedString = uuid + userId;
    const hash = SHA256(combinedString).toString();
    return { sign: hash };
};
